/**
 * Stockist "Badge" custom-field values that drive store visibility rules.
 * A store flagged "Coming Soon!" appears on the landing page (so customers
 * know it's opening) but is hidden from the footer, BOPIS, Frame Review,
 * and Cart Drop Off until it opens.
 */
export const COMING_SOON_BADGE = "Coming Soon!";

export function isComingSoon(store) {
  const badge = store?.custom_fields?.find(
    (field) => field.name.includes("Badge")
  );
  return badge?.value === COMING_SOON_BADGE;
}
